import { Route, Routes as Switch } from "react-router-dom";
import AddCarrier from "./Carrier/Form/AddCarrier";
import EditCarrier from "./Carrier/Form/EditCarrier";
import CarrierOverview from "./Carrier/Overview/CarrierOverview";
import { AddEdc } from "./ExportDistributionCentres/Form/AddEdc";
import { EditEdc } from "./ExportDistributionCentres/Form/EditEdc";
import EdcOverview from "./ExportDistributionCentres/Overview/EdcOverview";
import { HomePage } from "./Home/Home";
import { AddOdc } from "./OriginDistributionCentres/Form/AddOdc";
import { EditOdc } from "./OriginDistributionCentres/Form/EditOdc";
import OdcOverview from "./OriginDistributionCentres/Overview/OdcOverview";
import EditPdsr from "./TransportNetwork/PlantDockSupplierRelations/EditPdsr/EditPdsr";
import PdsrOverviewGrid from "./TransportNetwork/PlantDockSupplierRelations/Overview/PdsrOverview";
import PdsrValidationItemGrid from "./TransportNetwork/PlantDockSupplierRelations/PdsrValidationItemGrid/PdsrValidationItemGrid";
import { AddPlant } from "./Plants/Form/AddPlant";
import { EditPlant } from "./Plants/Form/EditPlant";
import PlantOverview from "./Plants/Overview/PlantOverview";
import EditProject from "./Project/EditProject/EditProject";
import ProjectOverview from "./Project/ProjectOverview/ProjectOverview";
import RouteDetails from "./Routes/Details/RouteDetails";
import FtlRouteOverview from "./Routes/FullTruckLoad/FtlRouteOverview";
import ProposedFtlRouteOverview from "./Routes/FullTruckLoad/Proposed/ProposedFtlRouteOverview";
import { AddBidPack } from "./StaticNetwork/BidPacks/Form/AddBidPack";
import { EditBidPack } from "./StaticNetwork/BidPacks/Form/EditBidPack";
import BidPackOverview from "./StaticNetwork/BidPacks/Overview/BidPackOverview";
import { ManageCutOffGrid } from "./StaticNetwork/CutOff/ManageCutOffGrid";
import { AddRateAgreement } from "./StaticNetwork/RateAgreements/Form/AddRateAgreement";
import { EditRateAgreement } from "./StaticNetwork/RateAgreements/Form/EditRateAgreement";
import RateAgreementsOverview from "./StaticNetwork/RateAgreements/Overview/RateAgreementsOverview";
import { AddSupplier } from "./Supplier/Form/AddSupplier";
import { EditSupplier } from "./Supplier/Form/EditSupplier";
import SupplierOverview from "./Supplier/Overview/SupplierOverview";
import AddTTProtection from "./TransportNetwork/TTProtections/Form/AddTTProtection";
import EditTTProtection from "./TransportNetwork/TTProtections/Form/EditTTProtection";
import { TTProtectionOverview } from "./TransportNetwork/TTProtections/Overview/TTProtectionOverview";
import { UserRights } from "./UserRights/UserRights";
import {
  bidPackUrls,
  carrierUrls,
  contactUrls,
  cutOffTimeUrls,
  edcUrls,
  ftlRouteUrls,
  odcUrls,
  plantUrls,
  projectUrls,
  proposedFtlRouteUrls,
  rateAgreementUrls,
  returnNetworkUrls,
  spdrUrls,
  supplierUrls,
  ttProtectionUrls,
  validationBacklogUrls,
  whoAmIUrl,
} from "./URL/ApplicationUrls";
import WhoAmIPage from "./WhoAmIPage";
import { SpdrOverview } from "./TransportNetwork/SupplierPlantDockRelations/Overview/SpdrOverview";
import EditContact from "./Contact/Form/EditContact";
import ContactOverview from "./Contact/Overview/ContactOverview";
import { AddSpdr } from "./TransportNetwork/SupplierPlantDockRelations/Form/AddSpdr";
import { EditSpdr } from "./TransportNetwork/SupplierPlantDockRelations/Form/EditSpdr";
import { AddContact } from "./Contact/Form/AddContact";

export default function RouteContents() {
  return (
    <Switch>
      {/* Help */}
      <Route path="/Help" element={<UserRights />} />
      <Route path="/" element={<HomePage />} />
      <Route path={whoAmIUrl.uiPath} element={<WhoAmIPage />} />

      {/* Carrier */}
      <Route path={carrierUrls.base.uiPath} element={<CarrierOverview />} />
      <Route path={carrierUrls.addCarrier.uiPath} element={<AddCarrier />} />
      <Route path={carrierUrls.carrierWithId(":carrierId").uiPath} element={<EditCarrier />} />

      {/* Locations */}
      {/* Supplier */}
      <Route path={supplierUrls.base.uiPath} element={<SupplierOverview />} />
      <Route path={supplierUrls.addSupplier.uiPath} element={<AddSupplier />} />
      <Route path={supplierUrls.supplierWithId(":supplierId").uiPath} element={<EditSupplier />} />
      {/* Plant */}
      <Route path={plantUrls.base.uiPath} element={<PlantOverview />} />
      <Route path={plantUrls.addPlant.uiPath} element={<AddPlant />} />
      <Route path={plantUrls.plantWithId(":plantId").uiPath} element={<EditPlant />} />
      {/* EDC */}
      <Route path={edcUrls.base.uiPath} element={<EdcOverview />} />
      <Route path={edcUrls.addEdc.uiPath} element={<AddEdc />} />
      <Route path={edcUrls.mutateEdc(":edcId").uiPath} element={<EditEdc />} />

      {/* ODC */}
      <Route path={odcUrls.base.uiPath} element={<OdcOverview />} />
      <Route path={odcUrls.addOdc.uiPath} element={<AddOdc />} />
      <Route path={odcUrls.editOdc(":odcId").uiPath} element={<EditOdc />} />

      {/* Contacts */}
      <Route path={contactUrls.base.uiPath} element={<ContactOverview />} />
      <Route path={contactUrls.addContact.uiPath} element={<AddContact />} />
      <Route path={contactUrls.contactWithId(":contactId").uiPath} element={<EditContact />} />

      {/* Rate & Region */}
      {/* BID PACK */}
      <Route path={bidPackUrls.base.uiPath} element={<BidPackOverview />} />
      <Route path={bidPackUrls.addBidPack.uiPath} element={<AddBidPack />} />
      <Route path={bidPackUrls.uiPathForBidPackWithId(":bidPackId")} element={<EditBidPack />} />

      {/* Rate Agreement */}
      <Route path={rateAgreementUrls.base.uiPath} element={<RateAgreementsOverview />} />
      <Route
        path={cutOffTimeUrls.forRateAgreement.uiPathFor(":rateAgreementId")}
        element={<ManageCutOffGrid />}
      />
      <Route path={rateAgreementUrls.addRateAgreement.uiPath} element={<AddRateAgreement />} />
      <Route
        path={rateAgreementUrls.uiPathForRateAgreementWithId(":rateAgreementId")}
        element={<EditRateAgreement />}
      />

      {/* Transport Network */}
      <Route path={spdrUrls.base.uiPath} element={<SpdrOverview />} />
      <Route path={spdrUrls.addSpdr.uiPath} element={<AddSpdr />} />
      <Route path={spdrUrls.spdrWithId(":spdrId").uiPath} element={<EditSpdr />} />
      <Route path={returnNetworkUrls.pdsrOverview.uiPath} element={<PdsrOverviewGrid />} />
      <Route path={returnNetworkUrls.editPdsr(":pdsrId")} element={<EditPdsr />} />
      <Route path={ttProtectionUrls.base.uiPath} element={<TTProtectionOverview />} />
      <Route path={ttProtectionUrls.addTTProtection.uiPath} element={<AddTTProtection />} />
      <Route path={ttProtectionUrls.detailsFor(":ttProtectionId")} element={<EditTTProtection />} />

      {/* Routes */}
      <Route path={ftlRouteUrls.base.uiPath} element={<FtlRouteOverview />} />
      <Route path={ftlRouteUrls.detailsFor(":routeId")} element={<RouteDetails />} />
      <Route path={proposedFtlRouteUrls.base.uiPath} element={<ProposedFtlRouteOverview />} />

      {/* Projects */}
      <Route path={projectUrls.base.uiPath} element={<ProjectOverview />} />
      <Route path={projectUrls.projectWithId(":projectId").uiPath} element={<EditProject />} />

      {/* Validation Backlog */}
      <Route path={validationBacklogUrls.pdsrs.uiPath} element={<PdsrValidationItemGrid />} />
    </Switch>
  );
}
